import React, { useEffect, useRef, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { MRT_Cell } from 'material-react-table';

import { AlarmDefinition } from 'types/types';
import { notAvailableData } from 'components/AlarmManagement/helpers';

interface TableCellTooltipProps {
  cell: MRT_Cell<AlarmDefinition, any>;
}

const TableCellTooltip: React.FC<TableCellTooltipProps> = ({ cell }) => {
  const cellValue = cell.getValue();
  const [isEllipsized, setIsEllipsized] = useState(false);
  const cellRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkEllipsis = () => {
      if (cellRef.current) {
        setIsEllipsized(
          cellRef.current.scrollWidth > cellRef.current.clientWidth
        );
      }
    };
    checkEllipsis();
    window.addEventListener('resize', checkEllipsis);
    return () => window.removeEventListener('resize', checkEllipsis);
  }, []);

  return (
    <Tooltip
      title={
        isEllipsized
          ? cellValue && cellValue != notAvailableData
            ? cellValue
            : cellValue == notAvailableData
            ? ''
            : ''
          : ''
      }
    >
      <div
        ref={cellRef}
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          cursor: isEllipsized ? 'pointer' : 'default',
        }}
      >
        {cellValue && cellValue != notAvailableData
          ? cellValue && cellValue != notAvailableData
            ? cellValue
            : cellValue == notAvailableData
            ? ''
            : ''
          : ''}
      </div>
    </Tooltip>
  );
};

export default TableCellTooltip;
